import React from "react";

export default function RightButton() {
    return (
        <svg width="33" height="33" viewBox="0 0 24 24">
            <title>arrow right</title>
            <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"></path>
        </svg>
    );
}
